module.exports = __webpack_public_path__ + "static/img/comment.236c5ce5.svg";